import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const InfoBubbleIllustration = ({
  title,
  width = 40,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 170">
      <g id="Frame" clipPath="url(#clip0_97_376)">
        <path
          id="bubble"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M170 85C170 38.0375 131.962 0 85 0C38.0375 0 0 38.0375 0 85C0 131.962 38.0375 170 85 170C101.49 170 116.875 165.283 129.88 157.165L167.153 167.153L157.165 129.88C165.283 116.875 170 101.49 170 85Z"
          fill="#FFBF00"
        />
        <path
          id="shadow"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85 0V170C101.49 170 116.875 165.283 129.88 157.165L167.153 167.153L157.165 129.88C165.283 116.875 170 101.49 170 85C170 38.0375 131.963 0 85 0Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          id="i"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.035 46.58C74.035 52.615 78.965 57.545 85 57.545C91.035 57.545 95.965 52.615 95.965 46.58C95.965 40.545 91.0775 35.615 85 35.615C78.965 35.615 74.035 40.545 74.035 46.58ZM104.21 128.86H85H65.79V112.37H74.035V79.4751H65.79V63.0276H85H95.965V79.4751V112.37H104.21V128.86Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_97_376">
          <rect width="170" height="170" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </DefaultIconWrapper>
);
